import React from 'react';

const NotFound = () => {
    return (
        <div>
            <h1>oops! Your page is not found</h1>
            <p>404</p>
        </div>
    );
};

export default NotFound;